// @ts-nocheck
import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { orderDetailsSubTitle } from "@store/Themes/common/props/orderDetails";

Object.assign(billingAddressStyles, {
    wrapper: orderDetailsSubTitle.wrapper,
    titleText: orderDetailsSubTitle.titleText,
});
